import { queryOptions, useQuery } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

const WOOP_WORKLOAD_RECOMMENDATION_MANIFEST_QUERY_KEY =
  'woop-workload-recommendation-manifest';

const getWorkloadRecommendationManifestQueryKey = ({
  clusterId,
  workloadId,
}: { clusterId?: string; workloadId?: string } = {}) =>
  [
    WOOP_WORKLOAD_RECOMMENDATION_MANIFEST_QUERY_KEY,
    clusterId,
    workloadId,
  ] as const;

export type UseWorkloadRecommendationManifestQueryArgs = {
  clusterId?: string;
  workloadId?: string;
  enabled?: boolean;
};

const getWorkloadRecommendationManifestQueryOptions = ({
  clusterId,
  workloadId,
  enabled,
}: UseWorkloadRecommendationManifestQueryArgs) =>
  queryOptions({
    queryKey: getWorkloadRecommendationManifestQueryKey({
      clusterId,
      workloadId,
    }),
    queryFn: async () => {
      const { data } =
        await apiClient.workloadOptimization.getWorkloadRecommendationManifest({
          clusterId: clusterId!,
          workloadId: workloadId!,
        });
      return data;
    },
    enabled: makeIsEnabled(enabled, !!(clusterId && workloadId)),
  });

export const useWorkloadRecommendationManifestQuery = (
  args: UseWorkloadRecommendationManifestQueryArgs
) => {
  const { data, isLoading, error, refetch } = useQuery(
    getWorkloadRecommendationManifestQueryOptions(args)
  );

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
